// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1058Z","alert":"SettungsInbox_alert__2ROL5"};